/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type WorkOrdersTableQueryVariables = Types.Exact<{
  input: Types.WorkOrdersByRegionInput
}>

export type WorkOrdersTableQuery = {
  __typename?: 'Query'
  workOrdersByRegion: {
    __typename?: 'WorkOrdersQueryResponse'
    total: number
    workOrders: Array<{
      __typename?: 'WorkOrder'
      createdAt: string
      description: string | null
      dueAt: string | null
      id: string
      operationalImpact: Types.WorkOrderOperationalImpact | null
      orderNumber: number
      priority: Types.WorkOrderPriority | null
      status: Types.WorkOrderStatus
      serviceCategory: Types.WorkOrderServiceCategory | null
      serviceItem: Types.WorkOrderServiceItem
      statusChangedAt: string | null
      assignee: {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      } | null
      createdBy: {
        __typename?: 'BackofficeUser'
        firstName: string
        lastName: string
      } | null
      statusChangedBy: {
        __typename?: 'BackofficeUser'
        firstName: string
        lastName: string
      } | null
      vehicle: {
        __typename?: 'Vehicle'
        id: string
        isSelfDriving: boolean
        label: number | null
        baseServiceBreakLocation: {
          __typename?: 'ServiceBreakLocation'
          name: string
        } | null
        currentlyLocatedInServiceBreakLocation: {
          __typename?: 'ServiceBreakLocation'
          id: string
        } | null
        fleet: { __typename?: 'Fleet'; name: string } | null
      } | null
    }>
  }
}

export const WorkOrdersTableDocument = gql`
    query WorkOrdersTable($input: WorkOrdersByRegionInput!) {
  workOrdersByRegion(input: $input) {
    total
    workOrders {
      assignee {
        id
        firstName
        lastName
      }
      createdAt
      createdBy {
        firstName
        lastName
      }
      description
      dueAt
      id
      operationalImpact
      orderNumber
      priority
      status
      serviceCategory
      serviceItem
      statusChangedAt
      statusChangedBy {
        firstName
        lastName
      }
      vehicle {
        baseServiceBreakLocation {
          name
        }
        currentlyLocatedInServiceBreakLocation {
          id
        }
        fleet {
          name
        }
        id
        isSelfDriving
        label
      }
    }
  }
}
    `

/**
 * __useWorkOrdersTableQuery__
 *
 * To run a query within a React component, call `useWorkOrdersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrdersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrdersTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkOrdersTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkOrdersTableQuery,
    WorkOrdersTableQueryVariables
  > &
    (
      | { variables: WorkOrdersTableQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WorkOrdersTableQuery, WorkOrdersTableQueryVariables>(
    WorkOrdersTableDocument,
    options,
  )
}
export function useWorkOrdersTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkOrdersTableQuery,
    WorkOrdersTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    WorkOrdersTableQuery,
    WorkOrdersTableQueryVariables
  >(WorkOrdersTableDocument, options)
}
// @ts-ignore
export function useWorkOrdersTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkOrdersTableQuery,
    WorkOrdersTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkOrdersTableQuery,
  WorkOrdersTableQueryVariables
>
export function useWorkOrdersTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrdersTableQuery,
        WorkOrdersTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkOrdersTableQuery | undefined,
  WorkOrdersTableQueryVariables
>
export function useWorkOrdersTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrdersTableQuery,
        WorkOrdersTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    WorkOrdersTableQuery,
    WorkOrdersTableQueryVariables
  >(WorkOrdersTableDocument, options)
}
export type WorkOrdersTableQueryHookResult = ReturnType<
  typeof useWorkOrdersTableQuery
>
export type WorkOrdersTableLazyQueryHookResult = ReturnType<
  typeof useWorkOrdersTableLazyQuery
>
export type WorkOrdersTableSuspenseQueryHookResult = ReturnType<
  typeof useWorkOrdersTableSuspenseQuery
>
export type WorkOrdersTableQueryResult = Apollo.QueryResult<
  WorkOrdersTableQuery,
  WorkOrdersTableQueryVariables
>
